import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { TreoModule } from '@treo';
import { TreoConfigModule } from '@treo/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { EnvServiceProvider } from './env.service.provider';
import { AppConfigService } from './app-config.service';
import { AuthService } from '@kimaya/ngx-auth-service';
import { TranslationLoaderService } from '@kimaya/ngx-base-common-hive';
import { AuthenticationEn } from './modules/auth/i18n/en';

export function ConfigLoader(configService: AppConfigService): any {
  return (): Promise<any> => configService.init();
}

const routerConfig: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  preloadingStrategy: PreloadAllModules,
  relativeLinkResolution: 'legacy',
  useHash: true
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Treo & Treo Mock API
    TreoModule,
    TreoConfigModule.forRoot(appConfig),

    // Core
    CoreModule,

    // Layout
    LayoutModule,

    // 3rd party modules
    MarkdownModule.forRoot({}),

  ],
  providers: [EnvServiceProvider, AppConfigService, AuthService,
    {provide: APP_INITIALIZER, useFactory: ConfigLoader, deps: [AppConfigService], multi: true},
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor(private translationLoaderService: TranslationLoaderService) {
    this.translationLoaderService.loadTranslations(AuthenticationEn);
  }
}
